import { useTranslation } from 'react-i18next';

const LANGUAGES = ['en', 'ja', 'es'] as const;

export function LanguageSelector() {
  const { i18n, t } = useTranslation();

  return (
    <select
      value={i18n.language?.slice(0, 2) || 'en'}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      className="language-selector"
      aria-label="Language"
    >
      {LANGUAGES.map((lng) => (
        <option key={lng} value={lng}>
          {t(`language.${lng}`)}
        </option>
      ))}
    </select>
  );
}
